export function OptinCTSBoxViewConstructor(services, callbacks, context, siteTypeConfig) {
  let joint = services.joint;
  let companyId = context.companyId;
  let site = context.site;
  let scenarioId = context.scenarioId;

  return joint.shapes.html.AbstractBoxElementWithDragAndDropView.extend({
    isElementEditable: false,

    angularTemplate: require('./OptinCTSBoxView.html'),
    initialize: function () {
      joint.shapes.html.AbstractBoxElementView.prototype.initialize.apply(this, arguments);
      this.optinCTSSelected = false;
    },

    createOptinCTSTitle: function (id, elementData) {
      const item = new joint.shapes.html.OptinCTSTitle({
        id: id,
        elementData: elementData,
      });
      this.model.embed(item);
      this.optinCTSSelected = true;
      return item;
    },

    addOptinCTSTitle: async function () {
      services.$mdDialog
        .show({
          controller: 'chooseOptinCTSTitleController',
          template: require('./chooseOptinCTSTitle.modal.html'),
          locals: {
            context: {
              site: site,
              companyId: companyId,
              scenarioId: scenarioId,
            },
            elementData: null,
          },
        })
        .then(async result => {
          if (result && result.type === 'ok') {
            const items = [];
            const response = await services.QuickRepliesFactory.createUniqueId(companyId, site.id, scenarioId);
            items.push(this.createOptinCTSTitle(response.data.id, result.data));
            this.model.graph.addCells(items);
          }
        });
    },
  });
}
